//
//
//
//
//

import LayoutBase from '~/components/public/layout/base';
export default {
  components: {
    LayoutBase,
  },
};
